module.exports = __webpack_public_path__ + "img/about3.aabdd867.png";